module.exports = __webpack_public_path__ + "static/media/login_sidebar_bg.d1e6887a.svg";